import { useDataSourceColumns } from "@/hooks";
import type { FillMissingTransformer } from "@/types/workspace";
import { Flex, Input, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerFillMissing({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: FillMissingTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: FillMissingTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0]?.column || "");
  const [value, setValue] = useState(String(data.item_list[0]?.value || ""));
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0]?.column || "");
    setValue(String(data.item_list[0]?.value || ""));
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column: value, value: data.item_list[0]?.value || "" }],
        });
      }
    }
  };

  const handleValueChange = (val: string) => {
    setValue(val);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ column, value: val }],
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Flex direction="row" gap={8}>
        <Select
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Column"
          data={availableColumns.length > 0 ? availableColumns : []}
          value={column}
          onChange={handleColumnChange}
        />
        <Input
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Value"
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
        />
      </Flex>
    </TransformerBase>
  );
}
